import { useMutation } from '@tanstack/react-query';

import { mediaManagerClient } from '@/lib/axios';
import { MutationConfig, queryClient } from '@/lib/react-query';
import { useNotificationStore } from '@/stores/notifications';
import { parseError } from '@/utils/axios';

import { supportsQueryKeys } from './query-keys';

type TDeleteSupport = {
  id: number;
};

const deleteSupport = ({ id }: TDeleteSupport): Promise<unknown> => {
  return mediaManagerClient.delete(`/api/v1/supports/${id}`);
};

type MutationFn = typeof deleteSupport;

type UseDeleteSupportParams = {
  config?: MutationConfig<MutationFn>;
};

export const useDeleteSupport = ({ config }: UseDeleteSupportParams = {}) => {
  const { addErrorNotification, addSuccessNotification } = useNotificationStore();

  return useMutation({
    onError(error) {
      const { status } = parseError(error);
      console.error(error);

      if (status === 404) {
        return addErrorNotification('El soporte no existe');
      }
      addErrorNotification('No se ha podido eliminar el soporte');
    },
    onSuccess() {
      queryClient.invalidateQueries({ queryKey: supportsQueryKeys.all });
      addSuccessNotification('El soporte se ha eliminado correctamente');
    },
    ...config,
    mutationFn: deleteSupport,
  });
};
